import Library from './scene/utility/Library';
import update3keys from './library/update3keys.json';
import milestonelist from './library/milestones.json';

// Versioned migration thresholds describe historical saves. Current release
// limits are resolved from champion JSON by championProgression.js and User.

const quests = Library.quests;

const devotionDefaults = () => ({
    maze: { rank: 1, selected: 1, progress: 0 },
    exp: { rank: 1, selected: 1, progress: 0 },
    passive: { rank: 1, selected: 1, progress: 0 },
    health: { rank: 1, selected: 1, progress: 0 },
    cards: { rank: 1, selected: 1, progress: 0 }
});

const devotionRequirement = rank => rank * (rank + 1) * 50;

const devotionForTrait = (rank, selected=rank) => {

    rank = Math.max(1, Math.round(rank || 1));
    selected = Math.max(1, Math.min(rank, Math.round(selected || rank)));
    return { rank, selected, progress: 0 };
};

const addDevotionProgress = (devotion, exp) => {

    devotion.progress += Math.max(0, Math.round(exp || 0));
    while (devotion.progress >= devotionRequirement(devotion.rank)) {
        devotion.progress -= devotionRequirement(devotion.rank);
        devotion.rank++;
        devotion.selected = devotion.rank;
    }
};

const halfTraitProgress = rank => {

    rank = Math.max(1, Math.round(rank || 1));
    let progress = 0;
    for (let i = 1; i < rank; i++)
        progress += devotionRequirement(i) / 2;
    return progress;
};

const clone = value => JSON.parse(JSON.stringify(value));

const valueFrom = (source, ...keys) => {

    for (let key of keys) {
        if (source && source[key] !== undefined)
            return source[key];
    }
    return undefined;
};

const celestialForDevotion = {
    maze: "nilith",
    passive: "aurora",
    health: "zephyrus",
    cards: "amaryllis"
};

const regenerationCosts = [10, 30, 60, 100, 150, 210, 280, 360, 450, 550, 660, 780];

const traitRefund = (rank, costs) => {

    rank = Math.max(1, Math.round(rank || 1));
    return costs.slice(0, rank - 1).reduce((total, cost) => total + cost, 0);
};

const convertOldShards = shards => {

    shards = Math.max(0, Math.round(shards || 0));
    return shards * 2;
};

const normalizeMetCelestials = value => {

    if (Array.isArray(value))
        return value;
    if (typeof value === "string") {
        try {
            const parsed = JSON.parse(value);
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            return [];
        }
    }
    return [];
};

const normalizeMilestones = value => {

    if (!value)
        return {};
    if (typeof value === "string") {
        try {
            const parsed = JSON.parse(value);
            return parsed && typeof parsed === "object" ? parsed : {};
        } catch (e) {
            return {};
        }
    }
    return typeof value === "object" ? value : {};
};

const setMilestoneAtLeast = (milestones, key, value) => {

    if (!key || (milestones[key] || 0) >= value)
        return;
    milestones[key] = value;
};

const oldStageMilestoneCompleted = (stage, oldStages, oldTraits) => {

    switch (stage) {
    case 1:
        return oldStages >= 2;
    case 2:
        return oldStages >= 4;
    case 3:
        return (oldTraits.mazePower || 1) >= 2;
    default:
        return false;
    }
};

const sanitizeSavedRunDecks = championData => {

    if (!championData || !championData.stats || !Array.isArray(championData.stats.runs))
        return;
    championData.stats.runs.forEach(run => {
        if (!Array.isArray(run.deck))
            return;
        run.deck = run.deck.map(card => {
            const key = card && card.key ? card.key : card;
            let model = null;
            try {
                model = Library.getCard(key);
            } catch (e) {
                model = null;
            }
            if (key === "doubt" || (model && !model.token))
                return card;
            if (card && typeof card === "object")
                return Object.assign({}, card, { key: "doubt" });
            return "doubt";
        });
    });
};

export function isOlderOrEqual(version1, version2) {
    const v1Parts = version1.split('.').map(Number);
    const v2Parts = version2.split('.').map(Number);

    const maxLength = Math.max(v1Parts.length, v2Parts.length);

    for (let i = 0; i < maxLength; i++) {
        const v1 = v1Parts[i] || 0;
        const v2 = v2Parts[i] || 0;

        if (v1 < v2) {
            return true;
        } else if (v1 > v2) {
            return false;
        }
    }

    return true;
}

export function updateSaveData(savedata) {

    const version = savedata.version;

    if (isOlderOrEqual(version, "0.3")) {
        // Can't load saves from update 2 or older
        savedata = { version };
    }

    if (isOlderOrEqual(version, "0.4")) {
        let data = JSON.parse(savedata.data);
        // Removing runes
        Object.keys(data).forEach(key => {
            let championdata = data[key].challenge;
            championdata.shards += Math.round(championdata.runes/2);
            championdata.traits.cardRank = championdata.traits.startingLevel;
        })
        savedata.data = JSON.stringify(data);
    }

    if (isOlderOrEqual(version, "0.4.1")) {
        let data = JSON.parse(savedata.data);
        Object.keys(data).forEach(key => {
            let championdata = data[key].challenge;
            delete championdata.stats.roomsCleared;
            delete championdata.stats.bossesSlain;
            championdata.selectedTraits = championdata.traits;
            /*//if (championdata.progress === 3) {
                //championdata.maxLevel = 10;
                switch (key) {
                case "1": championdata.quest = 2; break;
                case "2": championdata.quest = 1002; break;
                case "3": championdata.quest = 2002; break;
                case "4": championdata.quest = 3002; break;
                default: break;
                }
            //}*/
            championdata.stats.runs.forEach(run => {
                run.deck = run.deck.map(cardkey => { return { key: update3keys.cards[cardkey], status: "enabled" } });
                run.minDeckSize = run.deck.length;
            })
        })
        delete data.upgrades;
        savedata.data = JSON.stringify(data);
        if (savedata.collection) {
            let collection = JSON.parse(savedata.collection);
            Object.keys(collection).forEach(key => {
                if (key === "cards" && !Array.isArray(collection[key])) {
                    collection[key] = Object.fromEntries(Object.entries(collection[key]).map(([elkey, value]) => [update3keys[key][elkey], value]).filter(([elkey]) => elkey));
                    return;
                }
                collection[key] = collection[key].map(elkey => update3keys[key][elkey])
            })
            savedata.collection = JSON.stringify(collection);
        }
    }

    if (isOlderOrEqual(version, "0.4.5")) {
        let data = JSON.parse(savedata.data);
        let beryldata = data[4].challenge;
        if (!beryldata.quest || (beryldata.quest === 3003 && beryldata.maxLevel === 6)) {
            beryldata.quest = 3003;
            beryldata.maxLevel = 10;
            beryldata.traits.mazePower = 2;
            beryldata.selectedTraits.mazePower = 2;
        }
        const traitsRefund = {
            "hpPerLevel": [50, 200, 500, 1000],
            "startingGold": [20, 120, 520],
            "seed": [100, 400],
            "berry": [100, 400],
            "coin": [200],
            "worship": [50, 200, 500, 1000]
        }
        Object.keys(data).forEach(key => {
            let traitsdata = data[key].challenge.traits;
            let shardRefund = 0;
            Object.keys(traitsRefund).forEach(trait => {
                if (traitsRefund[trait] && traitsdata[trait] > 1)
                    shardRefund += traitsRefund[trait][traitsdata[trait]-2];
                traitsdata[trait] = 1;
                data[key].challenge.selectedTraits[trait] = 1;
            })
            data[key].challenge.shards += shardRefund;
        })
        let gallery = JSON.parse(savedata.gallery);
        if (gallery.includes(-1))
            gallery.push(-100);
        if (gallery.includes(3014))
            gallery.push(3016);
        if (gallery.includes(3015))
            gallery.push(3017);
        gallery = gallery.filter(n => n !== -1 && n !== 3014 && n !== 3015)
        savedata.data = JSON.stringify(data);
        savedata.gallery = JSON.stringify(gallery);
    }

    if (isOlderOrEqual(version, "0.4.6")) {
        let data = JSON.parse(savedata.data);
        Object.keys(data).forEach(key => {
            let championdata = data[key].challenge;
            if (championdata.maxLevel === 3 && championdata.quest%1000 === 2)
                championdata.maxLevel = 6;
            if (championdata.maxLevel === 6 && championdata.quest%1000 === 3 && key === "4")
                championdata.maxLevel = 10;
        })
        savedata.data = JSON.stringify(data);
    }

    if (isOlderOrEqual(version, "0.4.7")) {
        let data = JSON.parse(savedata.data);
        Object.keys(data).filter(key => key !== "4").forEach(key => {
            let championdata = data[key].challenge;
            if (championdata.maxLevel === 3 && (!championdata.quest || championdata.quest%1000 === 3)) {
                championdata.maxLevel = 6;
                championdata.quest = key*1000+2;
            }
        })
        savedata.data = JSON.stringify(data);
    }

    if (isOlderOrEqual(version, "0.5.1")) {
        let data = JSON.parse(savedata.data);
        Object.keys(data).filter(key => key === "4").forEach(key => {
            let championdata = data[key].challenge;
            if (championdata.quest && championdata.quest/1000 > 4)
                championdata.quest -= 1000;
        })
        savedata.data = JSON.stringify(data);
    }

    if (isOlderOrEqual(version, "0.5.4")) {
        let data = JSON.parse(savedata.data);
        let championdata = data[4].challenge;
        if (championdata.maxLevel === 6 && (!championdata.quest || championdata.quest%1000 === 3)) {
            championdata.maxLevel = 10;
            championdata.quest = 3003;
            championdata.progress = 3;
        }
        championdata = data[2].challenge;
        if (championdata.maxLevel === 6 && (!championdata.quest || championdata.quest%1000 === 3)) {
            championdata.maxLevel = 10;
            championdata.quest = 1003;
            championdata.progress = 3;
            championdata.traits.mazePower = 2;
            championdata.selectedTraits.mazePower = 2;
        }
        savedata.data = JSON.stringify(data);
    }

    if (isOlderOrEqual(version, "0.5.6")) {
        let data = JSON.parse(savedata.data);
        Object.keys(data).forEach(key => {
            let cdata = data[key].challenge;
            delete cdata.maxLevel;
        });
        let championdata = data[1].challenge;
        if (championdata.progress === 3 && (!championdata.quest || championdata.quest%1000 === 3)) {
            championdata.quest = 3;
            championdata.progress = 3;
            championdata.traits.mazePower = 2;
            championdata.selectedTraits.mazePower = 2;
        }
        savedata.data = JSON.stringify(data);
    }

    if (isOlderOrEqual(version, "0.5.7")) {
        let data = JSON.parse(savedata.data);
        let championdata = data[1].challenge;
        if (championdata.quest)
            championdata.quest = championdata.quest%1000;
        savedata.data = JSON.stringify(data);
    }

    if (isOlderOrEqual(version, "0.5.8")) {
        let data = JSON.parse(savedata.data);
        let championdata = data[3].challenge;
        if (championdata.progress === 3 && (!championdata.quest || championdata.quest%1000 === 3)) {
            championdata.quest = 3;
            championdata.progress = 3;
            championdata.traits.mazePower = 2;
            championdata.selectedTraits.mazePower = 2;
        }
        savedata.data = JSON.stringify(data);
    }

    if (isOlderOrEqual(version, "0.5.9")) {
        let data = JSON.parse(savedata.data);
        let championdata = data[3].challenge;
        if (championdata.progress >= 3 && (!championdata.quest || championdata.quest%1000 === 3)) {
            championdata.quest = 2003;
            championdata.progress = 3;
        }
        savedata.data = JSON.stringify(data);
    }

    if (isOlderOrEqual(version, "6.1.0")) {
        let data = JSON.parse(savedata.data);
        let gallery = JSON.parse(savedata.gallery);
        if (gallery.includes(-99))
            gallery.push(-95);
        if (Object.values(data).every(championdata => championdata.challenge.progress === 1))
            gallery = gallery.filter(e => e !== -99);
        savedata.gallery = JSON.stringify(gallery);
    }

    if (isOlderOrEqual(version, "8.0.0")) {
        let collection = JSON.parse(savedata.collection);
        if (Array.isArray(collection.cards))
            collection.cards.push("strike-spinelle", "defend-spinelle", "turn-around");
        else
            Object.assign(collection.cards, {
                "strike-spinelle": collection.cards["strike-spinelle"] || {},
                "defend-spinelle": collection.cards["defend-spinelle"] || {},
                "turn-around": collection.cards["turn-around"] || {}
            });
        savedata.collection = JSON.stringify(collection);
    }

    if (isOlderOrEqual(version, "8.0.3")) {
        let data = JSON.parse(savedata.data);
        if (data[5]) {
            if (data[5].challenge.maxLevel === 10)
                data[5].challenge.maxLevel = 6;
        }
        savedata.data = JSON.stringify(data);
    }

    if (isOlderOrEqual(version, "8.1.0")) {
        let data = JSON.parse(savedata.data);
        savedata.difficulty = "challenge";
        Object.keys(data).forEach(key => data[key].casual = data[key].challenge)
        savedata.data = JSON.stringify(data);
    }

    if (isOlderOrEqual(version, "8.2.0")) {
        let data = JSON.parse(savedata.data);
        let metCelestials = normalizeMetCelestials(savedata.metCelestials);
        let milestones = normalizeMilestones(savedata.milestones);
        const upgradedCelestials = { health: false, passive: false, cards: false };
        let totalRunsPlayed = 0;

        savedata.difficulty = "challenge";

        Object.keys(data).forEach(key => {
            const oldChallenge = clone(data[key].challenge);
            const oldTraits = oldChallenge.traits || {};
            const oldSelectedTraits = oldChallenge.selectedTraits || oldTraits;
            const devotion = devotionDefaults();
            const championMilestones = Object.values(milestonelist[key] || {});
            const oldLevel = oldChallenge.level || 1;
            const oldStoryProgress = Math.max(0, (oldChallenge.progress || 1) - 1);
            const oldStages = oldChallenge.stages || 1;

            totalRunsPlayed += oldChallenge.stats?.runsPlayed || 0;

            oldChallenge.shards = convertOldShards((oldChallenge.shards || 0) + traitRefund(oldTraits.hpRegeneration, regenerationCosts));
            sanitizeSavedRunDecks(oldChallenge);

            devotion.maze = devotionForTrait(
                valueFrom(oldTraits, "mazePower"),
                valueFrom(oldSelectedTraits, "mazePower")
            );
            devotion.cards = devotionForTrait(
                valueFrom(oldTraits, "cardRank", "cardUpgrade"),
                valueFrom(oldSelectedTraits, "cardRank", "cardUpgrade")
            );
            devotion.passive = devotionForTrait(
                valueFrom(oldTraits, "startingLevel"),
                valueFrom(oldSelectedTraits, "startingLevel")
            );

            addDevotionProgress(devotion.health, halfTraitProgress(valueFrom(oldTraits, "startingHp", "startingHealth")));
            addDevotionProgress(devotion.health, halfTraitProgress(valueFrom(oldTraits, "hpPerLevel", "healthPerLevel")));

            Object.keys(upgradedCelestials).forEach(devotionKey => {
                if (devotion[devotionKey].rank > 1)
                    upgradedCelestials[devotionKey] = true;
            });

            ["zen", "casual", "challenge"].forEach(difficulty => {
                data[key][difficulty] = Object.assign(clone(oldChallenge), { devotion: clone(devotion) });
            });

            Object.entries(celestialForDevotion).forEach(([devotionKey, celestial]) => {
                const devotionData = devotion[devotionKey];
                if ((devotionData.rank > 1 || devotionData.progress > 0) && !metCelestials.includes(celestial))
                    metCelestials.push(celestial);
            });

            championMilestones.forEach(milestone => {
                if (!milestone.check)
                    return;
                if (milestone.check.level && oldLevel >= milestone.check.level)
                    setMilestoneAtLeast(milestones, milestone.key, 3);
                if (milestone.check.story && oldStoryProgress >= milestone.check.story)
                    setMilestoneAtLeast(milestones, milestone.key, 3);
                if (milestone.check.stage && oldStageMilestoneCompleted(milestone.check.stage, oldStages, oldTraits))
                    setMilestoneAtLeast(milestones, milestone.key, 3);
            });
        });

        if (upgradedCelestials.health && upgradedCelestials.passive && upgradedCelestials.cards && !metCelestials.includes("nikara"))
            metCelestials.push("nikara");

        Object.values(milestonelist[0] || {}).forEach(milestone => {
            if (!milestone.check)
                return;
            if (milestone.check.runs && totalRunsPlayed >= milestone.check.runs)
                setMilestoneAtLeast(milestones, milestone.key, 1);
            if (milestone.check.celestial && metCelestials.includes(milestone.check.celestial))
                setMilestoneAtLeast(milestones, milestone.key, 1);
        });

        savedata.metCelestials = metCelestials;
        savedata.milestones = JSON.stringify(milestones);
        savedata.data = JSON.stringify(data);
    }

    // Check for save coherence on current version
    if (true) {
        let data = JSON.parse(savedata.data);
        Object.values(data).forEach(championData => {
            Object.values(championData).forEach(difficultyData => {
                delete difficultyData.exp;
                delete difficultyData.runes;
                delete difficultyData.soul;
                delete difficultyData.traits;
                delete difficultyData.selectedTraits;
                sanitizeSavedRunDecks(difficultyData);
                if (!difficultyData.devotion)
                    difficultyData.devotion = {};
                ["maze", "exp", "passive", "health", "cards"].forEach(devotion => {
                    if (!difficultyData.devotion[devotion])
                        difficultyData.devotion[devotion] = { rank: 1, selected: 1, progress: 0 };
                });
            });
        });
        Object.keys(data).filter(key => key !== "5").forEach(key => {
            let championdata = data[key].challenge;
            if (championdata.level > 10)
                championdata.level = 10;
        })

        savedata.data = JSON.stringify(data);
    }

    if (isOlderOrEqual(version, "8.8.0")) { // Shuts off current run on version change

        delete savedata["run.log"];
        delete savedata["run.save"];
    }
}
